export default __webpack_public_path__ + "static/filecleanedfromgolddust-85de354eb2e4563ad8869743d103cd28.png";